/**
 * A single selectable row inside the Errors popup. Selected rows are bold with a highlighted
 * background; the row is keyboard-operable (Enter / Space).
 */
import { observer } from "mobx-react";

interface IProps {
    label: string;
    count: number;
    isSelected: boolean;
    onToggle: () => void;
}

const RmaListErrorsPopupRow: React.FC<IProps> = observer(({ label, count, isSelected, onToggle }) => (
    <div
        role="button"
        tabIndex={0}
        className={`rma-list-errors-popup__row${isSelected ? " selected" : ""}`}
        onClick={onToggle}
        onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onToggle();
            }
        }}
    >
        <span className="rma-list-errors-popup__label">{label}</span>
        <span className="rma-list-errors-popup__count">{count}</span>
    </div>
));

export default RmaListErrorsPopupRow;
